const opcDaWriterLogHu = {
	opcDaWriterLogTable: 'OPC DA Writer Log',
	timestamp: 'Timestamp',
	tag: 'Tag',
	objective: 'Objective',
	state: 'State',
	name: 'Name',
	opcDaWriterLogEditForm: 'OPC DA Writer Log',
	basic: 'Basic',
	tableName: 'Table Name',
	description: 'Description',
	fields: 'Fields',
	type: 'Type',
	userGroup: 'User Group'
};

export default opcDaWriterLogHu;